<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Reading the Gospels with Karl Barth</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="OT" id="abb001"><a id="page_xi"></a><a href="#/xhtml/contents#abb-001">Abbreviations</a></p>
<table border="0" cellpadding="0" cellspacing="0" class="Table1">
<tbody><tr>
<td><i>CD</i></td>
<td>Karl Barth, <i>Church Dogmatics</i>, 4 vols. in 13 parts, trans. G. W. Bromiley and T. F. Torrance (Edinburgh: T. &amp; T. Clark, 1936–1975)</td>
</tr>
<tr>
<td><i>KD</i></td>
<td>Karl Barth, <i>Kirchliche Dogmatik</i>, 4 vols. in 13 parts (Zollikon-Zürich: Evangelischer Verlag, 1932–1967)</td>
</tr>
<tr>
<td>KJV</td>
<td>King James Version</td>
</tr>
<tr>
<td>NRSV</td>
<td>New Revised Standard Version</td>
</tr>
<tr>
<td><i>WW</i></td>
<td>Karl Barth, <i>Witness to the Word: A Commentary on John 1; Lectures at Münster in 1925 and at Bonn in 1933</i>, ed. Walther Fürst, trans. Geoffrey W. Bromiley (Grand Rapids: Eerdmans, 1986)</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?1fc495be